import * as React from "react";
import { useState } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@material-ui/core";
import MerchantsTab from "./MerchantsTab";
import GroupsTab from "./GroupsTab";
import UnmatchedTab from "./UnmatchedTab";
import CohortRulesTab from "./CohortRulesTab";
import CustomerLookupTab from "./CustomerLookupTab";
import CohortOverviewTab from "./CohortOverviewTab";

const TABS = ["Overview", "Merchants", "Competitor groups", "Unmatched bank text", "Cohort rules", "Customer lookup"];

const CloCohortsDashboard: React.FC = () => {
  const [tab, setTab] = useState(0);
  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom>
        CLO · Open Banking & Cohorts
      </Typography>
      <Paper>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" variant="scrollable">
          {TABS.map((label) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>
      </Paper>
      <Box mt={2}>
        {tab === 0 && <CohortOverviewTab />}
        {tab === 1 && <MerchantsTab />}
        {tab === 2 && <GroupsTab />}
        {tab === 3 && <UnmatchedTab />}
        {tab === 4 && <CohortRulesTab />}
        {tab === 5 && <CustomerLookupTab />}
      </Box>
    </Box>
  );
};

export default CloCohortsDashboard;
